import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate, useLocation, useParams } from 'react-router-dom';
import EnvSetting from "./EnvSetting";
import EnvHistory from "./EnvHistory";
import EnvMessages from "./EnvMessages";
import {
	checkTemplatePost,
	envelopeDownloadData,
	getEnvelopeSenderList,
	manageEnvelopeDocFormList,
	manageEnvelopeDocumentDetail,
	manageEnvelopeSignDocumentDetail,
	manageEnvelopeFillFormDetail,
	postCloudList,
	userEnvelopeDownloadData,
	viewMangeEnvelope
} from "../../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../../utils";
import BulkMessage from "./BulkMessage";
import ApproveRejectDoc from "./ApproveRejectDoc";
import ApproveRejectForm from "./ApproveRejectForm";
import ApproveRejectSignDoc from "./ApproveRejectSignDoc";
import TransferEnvelope from "./TransferEnvelope";
import CloseEnvelope from "./CloseEnvelope";
import ResendEnvelope from "./ResendEnvelope";
import FileDownload from "js-file-download";
import Axios from "axios";
import EditRequest from "./EditRequest";
import ViewDataForm from "./ViewDataForm";
import ViewDocument from "./ViewDocument";
import ViewSignDocument from "./ViewSignDocument";
import { SYNC_STATUS } from "../../../../../configs/AppConfig";
import DownloadDataDoc from "./DownloadDataDoc";
import './manage.css';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import { DocumentIcon, MessageIcon, HistoryIcon, SettingIcon } from '../../../../../assets/svg/allsvg';

function ViewEnvelope(props) {
	const location = useLocation();
	const { id } = useParams();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [envelopeData, setEnvelopeData] = useState({});
	const [recipientList, setRecipientList] = useState([]);
	const [currentRecipient, setCurrentRecipient] = useState('');
	const [currentRecipientId, setCurrentRecipientId] = useState(0);
	const [statusList, setStatusList] = useState([]);
	const [docFormList, setDocFormList] = useState({});
	const [downloadDataList, setDownloadDataList] = useState({});
	const [docList, setDocList] = useState([]);
	const [formList, setFormList] = useState([]);
	const [signDocList, setSignDocList] = useState([]);
	const [isDataDownload, setIsDataDownload] = useState(false);
	const [isDownloadFile, setIsDownloadFile] = useState(false);
	const [isEditRequest, setIsEditRequest] = useState(false);
	const [isRefresh, setIsRefresh] = useState(true);
	const [senderList, setSenderList] = useState([]);
	const [isTemplate, setIsTemplate] = useState(false);
	const [syncStatusList, setSyncStatusList] = useState(SYNC_STATUS);
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 200);
	const [isSmartSleeve, setIsSmartSleeve] = useState(false);
	const [activeTab, setActiveTab] = useState("document-form");

	const [docDetail, setDocDetail] = useState({
		id: 0,
		envelope_id: 0,
		recipient_id: 0,
		is_call: false,
		doc_detail: {}
	});
	const [formDetail, setFormDetail] = useState({
		id: 0,
		envelope_id: 0,
		recipient_id: 0,
		is_call: false,
		form_detail: {}
	});
	const [signDocDetail, setSignDocDetail] = useState({
		id: 0,
		envelope_id: 0,
		recipient_id: 0,
		is_call: false,
		sign_doc_detail: {}
	});
	const [resendEnvelope, setResendEnvelope] = useState({
		envelope_id: 0,
		emails: []
	});
	const [closeEnvelope, setCloseEnvelope] = useState({
		envelope_id: 0,
		recipient_email: '',
		recipient_id: 0
	});

	const approveRejectDocumentModelRef = useRef(null);
	const viewDocumentModelRef = useRef(null);
	const approveRejectDataModelRef = useRef(null);
	const viewDataModelRef = useRef(null);
	const DownloadDataModelRef = useRef(null);

	const viewSignDocumentModelRef = useRef(null);
	const approveRejectSignDocumentModelRef = useRef(null);

	console.log('is_smart_sleeve:', envelopeData.is_smart_sleeve);

	useEffect(function () {
		getEnvelopeSenderList()
			.then(response => {
				setSenderList(response.data.data);
			})
			.catch(err => {

			});
	}, []);

	useEffect(function () {
		postCloudList({})
			.then(response => {
				setSyncStatusList(response.data.data);
			})
			.catch(err => {

			});
	}, []);

	useEffect(function () {
		checkTemplatePost({})
			.then(response => {
				setIsTemplate(response.data.is_template);
			})
			.catch(err => {
			});
	}, []);

	useEffect(function () {
		if (id && isRefresh === true) {
			setLoading(true);
			viewMangeEnvelope({ uuid: id })
				.then(response => {
					setEnvelopeData(response.data.data);
					let rList = response.data.recipients;
					if (location?.state?.recipient_id) {
						for (let i = 0; i < rList.length; i++) {
							let active = false;
							if (parseInt(location?.state?.recipient_id) === parseInt(rList[i]['id'])) {
								active = true;
							}
							rList[i]['active'] = active;
						}
					}
					setRecipientList(rList);
					if (response.data.recipients.length > 0) {
						if (location?.state?.recipient_id) {
							setCurrentRecipientId(parseInt(location?.state?.recipient_id));
							setCurrentRecipient(location?.state?.recipient_name);
						} else {
							let recipientData = response.data.recipients[0];
							setCurrentRecipient(recipientData.first_name + ' ' + recipientData.last_name);
							setCurrentRecipientId(parseInt(recipientData.id));
						}
					}
					setIsDownloadFile(response.data.data.is_download_files);
					setIsRefresh(false);
					setLoading(false);
				})
				.catch(err => {
					setLoading(false);
					toast.error(Utils.getErrorMessage(err));
					navigate('/manage');
				});
		}
	}, [id, navigate, isRefresh, location?.state]);

	useEffect(function () {
		if (currentRecipientId > 0) {
			setLoading(true);
			setStatusList([]);
			manageEnvelopeDocFormList({ id: envelopeData.id, recipient_id: currentRecipientId })
				.then(response => {
					let sList = response.data.status_list;
					let sId = 0;
					if (props?.tabType) {
						if (props?.tabType !== 'message') {
							for (let s = 0; s < sList.length; s++) {
								let isActive = false;
								if (parseInt(sList[s]['id']) === parseInt(props.tabType)) {
									sId = parseInt(sList[s]['id']);
									isActive = true;
								}
								sList[s]['active'] = isActive;
							}
						}
					}

					setStatusList(sList);
					setDocFormList({
						doc_list: response.data.docList,
						form_list: response.data.formList,
						sign_doc_list: response.data.signDocList
					});
					setDocList(response.data.docList);
					setFormList(response.data.formList);
					setSignDocList(response.data.signDocList)
					setIsDataDownload(response.data.is_data_download);
					setIsSmartSleeve(response.data.is_smart_sleeve === true);

					let dataObj = {
						doc_list: response.data.docList,
						form_list: response.data.formList,
						sign_doc_list: response.data.signDocList
					};
					handleDocFormByDirectStatus(sId, dataObj);
					setLoading(false);
				})
				.catch(err => {
					setLoading(false);
					toast.error(Utils.getErrorMessage(err));
				});
		}
	}, [currentRecipientId, envelopeData, props?.tabType]);

	const handleRecipient = (e, data) => {
		e.preventDefault();
		let list = [...recipientList];
		for (let i = 0; i < list.length; i++) {
			let active = false;
			if (data.id === list[i]['id']) {
				active = true;
				setCurrentRecipient(data.first_name + ' ' + data.last_name);
				setCurrentRecipientId(parseInt(data.id));
			}
			list[i]['active'] = active;
		}
		setRecipientList(list);
	};

	const handleStatus = (e, data) => {
		e.preventDefault();
		let list = [...statusList];
		for (let i = 0; i < list.length; i++) {
			let active = false;
			if (parseInt(list[i]['id']) === parseInt(data.id)) {
				active = true;
			}
			list[i]['active'] = active;
		}
		setStatusList(list);

		handleDocFormByStatus(data.id);
	};

	const handleDocFormByStatus = (statusId) => {
		let dataList = { ...docFormList };
		let documentList = dataList.doc_list;
		let requestFormList = dataList.form_list;
		let signDocumentList = dataList.sign_doc_list;
		if (parseInt(statusId) === 0) {
			setDocList(documentList);
			setFormList(requestFormList);
			setSignDocList(signDocumentList);
		} else {
			let dList = [];
			let fList = [];
			let sdList = [];
			if (documentList.length > 0) {
				for (let d = 0; d < documentList.length; d++) {
					if (parseInt(documentList[d]['status_id']) === parseInt(statusId)) {
						dList.push(documentList[d]);
					}
				}
			}

			if (requestFormList.length > 0) {
				for (let f = 0; f < requestFormList.length; f++) {
					if (parseInt(requestFormList[f]['status_id']) === parseInt(statusId)) {
						fList.push(requestFormList[f]);
					}
				}
			}

			if (signDocumentList.length > 0) {
				for (let k = 0; k < signDocumentList.length; k++) {
					if (parseInt(signDocumentList[k]['status_id']) === parseInt(statusId)) {
						sdList.push(signDocumentList[k]);
					}
				}
			}

			setDocList(dList);
			setFormList(fList);
			setSignDocList(sdList);
		}
	};

	const handleDocFormByDirectStatus = (statusId, dataList) => {
		let documentList = dataList.doc_list;
		let requestFormList = dataList.form_list;
		if (parseInt(statusId) === 0) {
			setDocList(documentList);
			setFormList(requestFormList);
		} else {
			let dList = [];
			let fList = [];
			if (documentList.length > 0) {
				for (let d = 0; d < documentList.length; d++) {
					if (parseInt(documentList[d]['status_id']) === parseInt(statusId)) {
						dList.push(documentList[d]);
					}
				}
			}

			if (requestFormList.length > 0) {
				for (let f = 0; f < requestFormList.length; f++) {
					if (parseInt(requestFormList[f]['status_id']) === parseInt(statusId)) {
						fList.push(requestFormList[f]);
					}
				}
			}
			setDocList(dList);
			setFormList(fList);
		}
	};

	const onViewApproveRejectDoc = (e, data) => {
		e.preventDefault();
		setLoading(true);
		let obj = {
			id: data.id,
			envelope_id: envelopeData.id,
			recipient_id: currentRecipientId,
		};
		manageEnvelopeDocumentDetail(obj)
			.then(response => {
				setDocDetail({
					id: data.id,
					envelope_id: envelopeData.id,
					recipient_id: currentRecipientId,
					is_call: true,
					doc_detail: response.data.data
				});
				setLoading(false);
				viewDocumentModelRef?.current.click();
			})
			.catch(err => {
				toast.error(Utils.getErrorMessage(err));
				setLoading(false);
			});
	};

	const handleApproveRejectDoc = (e, data) => {
		e.preventDefault();
		e.stopPropagation();
		setLoading(true);
		let obj = {
			id: data.id,
			envelope_id: envelopeData.id,
			recipient_id: currentRecipientId
		};
		manageEnvelopeDocumentDetail(obj)
			.then(response => {
				setDocDetail({
					id: data.id,
					envelope_id: envelopeData.id,
					recipient_id: currentRecipientId,
					is_call: true,
					doc_detail: response.data.data
				});
				setLoading(false);
				approveRejectDocumentModelRef?.current.click();
			})
			.catch(err => {
				toast.error(Utils.getErrorMessage(err));
				setLoading(false);
			});
	};

	const handleViewDataForm = (e, data) => {
		e.preventDefault();
		setLoading(true);
		let obj = {
			id: data.id,
			envelope_id: envelopeData.id,
			recipient_id: currentRecipientId
		};
		manageEnvelopeFillFormDetail(obj)
			.then(response => {
				setFormDetail({
					id: data.id,
					envelope_id: envelopeData.id,
					recipient_id: currentRecipientId,
					is_call: true,
					form_detail: response.data.data
				});
				viewDataModelRef?.current.click();
				setLoading(false);
			})
			.catch(err => {
				toast.error(Utils.getErrorMessage(err));
				setLoading(false);
			});
	};

	const handleApproveRejectForm = (e, data) => {
		e.preventDefault();
		setLoading(true);
		let obj = {
			id: data.id,
			envelope_id: envelopeData.id,
			recipient_id: currentRecipientId
		};
		manageEnvelopeFillFormDetail(obj)
			.then(response => {
				setFormDetail({
					id: data.id,
					envelope_id: envelopeData.id,
					recipient_id: currentRecipientId,
					is_call: true,
					form_detail: response.data.data
				});
				approveRejectDataModelRef?.current.click();
				setLoading(false);
			})
			.catch(err => {
				toast.error(Utils.getErrorMessage(err));
				setLoading(false);
			});
	};

	const onEnvelopeClose = (e) => {
		e.preventDefault();

		setCloseEnvelope({
			envelope_id: envelopeData.id,
			recipient_id: 0
		});
	};

	const onEnvelopeTransfer = (e) => {
		e.preventDefault();

		setCloseEnvelope({
			envelope_id: envelopeData.id,
			recipient_id: 0
		});
	};

	const onEnvelopeResend = (e, type) => {
		e.preventDefault();

		if (type === 1) {
			let emails = [];

			for (let i = 0; i < recipientList.length; i++) {
				emails.push({
					id: recipientList[i]['id'],
					email: recipientList[i]['email'],
					name: recipientList[i]['first_name'] + ' ' + recipientList[i]['last_name']
				});
			}

			setResendEnvelope({
				envelope_id: envelopeData.id,
				emails: emails
			});
		} else {
			let index = recipientList.findIndex(x => parseInt(x.id) === parseInt(currentRecipientId));
			if (index > -1) {
				setResendEnvelope({
					envelope_id: envelopeData.id,
					emails: [{
						id: currentRecipientId,
						email: recipientList[index]['email'],
						name: recipientList[index]['first_name'] + ' ' + recipientList[index]['last_name']
					}]
				});
			}
		}
	};

	const onRecipientCloseEnvelope = (e) => {
		e.preventDefault();

		let email = '';
		let index = recipientList.findIndex(x => parseInt(x.id) === parseInt(currentRecipientId));
		if (index > -1) {
			email = recipientList[index]['email'];
		}

		setCloseEnvelope({
			envelope_id: envelopeData.id,
			email: email,
			recipient_id: currentRecipientId
		});
	};


	const downloadAllFileForm = (e) => {
		e.preventDefault();
		setLoading(true);
		let obj = {
			envelope_id: parseInt(envelopeData.id),
		};

		userEnvelopeDownloadData(obj)
			.then(res => {
				setDownloadDataList(res.data.data);
				DownloadDataModelRef?.current.click();
				setLoading(false);
			})
			.catch(err => {
				toast.error(Utils.getErrorMessage(err));
				setLoading(false);
			});
	};

	const onEditRequest = (e) => {
		e.preventDefault();
		setIsEditRequest(true);
	};

	const onDataDownload = (e, type) => {
		e.preventDefault();
		let obj = {
			envelope_id: envelopeData.id,
			recipient_id: currentRecipientId,
			type: type
		};
		setLoading(true);

		envelopeDownloadData(obj)
			.then(response => {
				Axios.get(response.data.fileUrl, {
					responseType: 'blob',
				}).then((res) => {
					setLoading(false);
					FileDownload(res.data, response.data.fileName);
				}).catch(err => {
					toast.error('Oops...something went wrong. File not found.');
					setLoading(false);
				});
			})
			.catch(err => {
				toast.error(Utils.getErrorMessage(err));
				setLoading(false);
			});
	};

	const handleCustomerPortal = (e) => {
		e.preventDefault();

		let index = recipientList.findIndex(x => parseInt(x.id) === parseInt(currentRecipientId));
		if (index > -1) {
			window.open('/client-portal/sleeve/view/' + envelopeData.uuid + '-.' + recipientList[index]['generated_id'], "_blank");
		} else {
			toast.error('Oops...something went wrong. Please try again.');
		}
	};

	const handleExpireDoc = (e) => {
		e.preventDefault();
		navigate('/manage/' + id + '/expired-document');
	};

	const onViewApproveRejectSignDoc = (e, data) => {
		e.preventDefault();
		setLoading(true);
		let obj = {
			id: data.id,
			envelope_id: envelopeData.id,
			recipient_id: currentRecipientId,
		};
		manageEnvelopeSignDocumentDetail(obj)
			.then(response => {
				setSignDocDetail({
					id: data.id,
					envelope_id: envelopeData.id,
					recipient_id: currentRecipientId,
					is_call: true,
					sign_doc_detail: response.data.data
				});

				setLoading(false);
				viewSignDocumentModelRef?.current.click();
			})
			.catch(err => {
				toast.error(Utils.getErrorMessage(err));
				setLoading(false);
			});
	};

	const handleApproveRejectSignDoc = (e, data) => {
		e.preventDefault();
		setLoading(true);
		let obj = {
			id: data.id,
			envelope_id: envelopeData.id,
			recipient_id: currentRecipientId
		};
		manageEnvelopeSignDocumentDetail(obj)
			.then(response => {
				setSignDocDetail({
					id: data.id,
					envelope_id: envelopeData.id,
					recipient_id: currentRecipientId,
					is_call: true,
					sign_doc_detail: response.data.data
				});
				setLoading(false);
				approveRejectSignDocumentModelRef?.current.click();
			})
			.catch(err => {
				toast.error(Utils.getErrorMessage(err));
				setLoading(false);
			});
	};


	return (
		<>
			{loading && <div className="page-loading">
				<img src="/images/loader.gif" alt="loader" />
			</div>}
			<section className="section-bg-color min-height-sleeve sleeve-spacing wrapper-sleeve">
				<div className="custom_container">
					<div className="sleeve-header">
						<div className="sleeve-title">
							<div className="sleeve-breadcrumb">
								<NavLink to={"/manage"} className="text-white fs-5 text-decoration-none">
									<i className="bi bi-folder2-open me-2"></i> Sleeves</NavLink>
								<i className="bi bi-chevron-double-right mx-3 fs-5" />{envelopeData.envelope_name}
							</div>
						</div>
						<div className="sleeve-actions">
							{parseInt(envelopeData.status_id) === 2 && parseInt(envelopeData.expired_day) > 0 && (
								<button type="button" onClick={handleExpireDoc}
									className="request-expired-docs-btn">
									<i className="bi bi-clock-history me-2"></i>Request Expired Docs
								</button>
							)}
							{isDownloadFile === true && (
								<button type="button" className="download-all-files-btn"
									data-toggle="tooltip"
									onClick={(e) => downloadAllFileForm(e)}
									data-placement="right" title="" data-bs-original-title="Click to Download All Files">
									<i className="bi bi-download me-2" aria-hidden="true" /> Download All Files
								</button>
							)}
							{!location?.state?.fromCompleted && statusList.length > 0 && (
								<Dropdown
									trigger={["click"]}
									overlay={
										<Menu className="custom-rc-dropdown-menu">
											<MenuItem key="resend" className="custom-rc-dropdown-item">
												<span
													onClick={(e) => onEnvelopeResend(e, 1)}
													data-bs-toggle="modal"
													data-bs-target="#resendEnvelope"
													className="d-flex align-items-center gap-2"
												>
													<i className="bi bi-envelope" style={{ fontSize: 18 }}></i>Resend Sleeves
												</span>
											</MenuItem>
											<MenuItem key="complete" className="custom-rc-dropdown-item">
												<span
													onClick={onEnvelopeClose}
													data-bs-toggle="modal"
													data-bs-target="#closeEnvelope"
													className="d-flex align-items-center gap-2"
												>
													<i className="bi bi-check-circle" style={{ fontSize: 18 }}></i>Complete Sleeves
												</span>
											</MenuItem>
											<MenuItem key="transfer" className="custom-rc-dropdown-item">
												<span
													onClick={onEnvelopeTransfer}
													data-bs-toggle="modal"
													data-bs-target="#transferEnvelope"
													className="d-flex align-items-center gap-2"
												>
													<i className="bi bi-arrow-left-right" style={{ fontSize: 18 }}></i>Transfer Sleeves
												</span>
											</MenuItem>
											{!isEditRequest && isSmartSleeve === false && (
												<MenuItem key="edit" className="custom-rc-dropdown-item">
													<span
														onClick={onEditRequest}
														className="d-flex align-items-center gap-2"
													>
														<i className="bi bi-pencil-square" style={{ fontSize: 18 }}></i>Edit Request
													</span>
												</MenuItem>
											)}
											<MenuItem key="add-recipient" className="custom-rc-dropdown-item">
												<NavLink to={`/manage/${id}/recipient`} className="d-flex align-items-center gap-2 text-decoration-none">
													<i className="bi bi-person-plus" style={{ fontSize: 18 }}></i>Add Another Recipient
												</NavLink>
											</MenuItem>
										</Menu>
									}
									animation="slide-up"
									placement="bottomRight"
								>
									<button className="dots-button menu-toggle" id="dropdownMenuButton1">
										<i className="bi bi-three-dots-vertical" style={{ fontSize: 18 }}></i>
									</button>
								</Dropdown>
							)}
						</div>
					</div>

					{!isEditRequest &&
						<>
							<div className="nav nav-tabs sleeve-tabs" id="nav-tab" role="tablist">
								<button className={`nav-link sleeve-tab ${props.tabType === 'message' ? `` : `active`}`}
									id="document-form" data-bs-toggle="tab"
									data-bs-target="#document-form-detail" type="button" role="tab"
									aria-controls="document-form-detail" aria-selected="true">
									<DocumentIcon />
									Documents & Information
								</button>
								<button className={`nav-link sleeve-tab ${props.tabType === 'message' ? `active` : ``}`}
									id="messages-tab" data-bs-toggle="tab" data-bs-target="#messages"
									type="button" role="tab" aria-controls="messages" aria-selected="false">
									<MessageIcon />
									Messages
									{envelopeData.is_message === true && (<span className="red_dot" />)}
								</button>
								<button className="nav-link sleeve-tab" id="History-tab" data-bs-toggle="tab" data-bs-target="#History"
									type="button" role="tab" aria-controls="History" aria-selected="false">
									<HistoryIcon />
									History
								</button>
								<button className="nav-link sleeve-tab" id="EnvSetting-tab" data-bs-toggle="tab"
									data-bs-target="#EnvSetting" type="button" role="tab" aria-controls="EnvSetting"
									aria-selected="false">
									<SettingIcon />
									Sleeves Settings
								</button>
							</div>


							<div className="tab-content sleeve-content" id="nav-tabContent">
								<div className={`tab-pane fade ${props.tabType === 'message' ? `` : `active show`}`}
									id="document-form-detail" role="tabpanel" aria-labelledby="document-form">
									<div className="row" >
										<div className="col-xxl-2 col-lg-3 col-md-3 col-sm-12 p-0">
											<div className="recipient-sidebar">
												{recipientList.map((item, index) => (
													<div
														key={index}
														onClick={(e) => handleRecipient(e, item)}
														className={`recipient-item ${item.active ? 'active' : ''}`}
													>
														<div className="recipient-name">
															<i className="bi bi-person-circle"></i>
															{item.first_name} {item.last_name}
														</div>
														<span className="recipient-count">{item.total}</span>
													</div>
												))}
											</div>
										</div>
										<div className="col-xxl-10 col-lg-9 col-md-9 col-sm-12 mt-4 mt-lg-0">
											<div className="tab-content" id="nav-tabContent">
												<div className="tab-pane fade active show" id="Name-one-detail"
													role="tabpanel">
													<div className="row">
														<div className="col-12">
															<div className="document-content">
																<div className="document-header">
																	<div className="status-filters" id="nav-tab"
																		role="tablist">
																		{statusList.map((item, index) =>
																			<button key={index}
																				onClick={(e) => handleStatus(e, item)}
																				className={`status-filter ${item.active ? `active` : ``} ${item.id === 0 ? `status-filter-all` : item.id === 1 ? `status-filter-pending` : item.id === 2 ? `status-filter-received` : item.id === 5 ? 'status-filter-declined' : item.id === 3 ? `status-filter-approved` : `status-filter-rejected`}`}
																				type="button" role="tab"
																				aria-selected="true">{item.name}
																				<span className="ms-1">({item.total})</span>
																			</button>
																		)}
																		{!location?.state?.fromCompleted && statusList.length > 0 && (
																			<div className="dropdown recipient-options-dropdown ms-2" >
																				<button
																					className="btn dropdown-toggle "
																					type="button"
																					id="recipientOptionsDropdown"
																					data-bs-toggle="dropdown"
																					aria-expanded="false"
																					aria-label={`Options for ${currentRecipient}`}
																				>
																					<span className="menu-toggle">
																						<i className="bi bi-three-dots-vertical"></i>
																					</span>
																				</button>
																				<ul className="dropdown-menu dropdown-menu-end shadow-sm" aria-labelledby="recipientOptionsDropdown">
																					{/* <li>
																						<button
																							className="dropdown-item d-flex align-items-center flex-row"
																							onClick={handleCustomerPortal}
																							aria-label="View Client Portal"
																							title="View the client portal for this recipient"
																						>
																							<i className="bi bi-person-badge me-2"></i>
																							View Client Portal
																						</button>
																				</li> */}
																					<li>
																						<button
																							className="dropdown-item d-flex align-items-center flex-row"
																							onClick={(e) => onEnvelopeResend(e, 2)}
																							data-bs-toggle="modal"
																							data-bs-target="#resendEnvelope"
																							aria-label="Resend Sleeve"
																							title="Resend the sleeve to the recipient"
																						>
																							<i className="bi bi-envelope me-2"></i>
																							Resend Sleeve
																						</button>
																					</li>
																					<li>
																						<button
																							className="dropdown-item d-flex align-items-center flex-row"
																							onClick={onRecipientCloseEnvelope}
																							data-bs-toggle="modal"
																							data-bs-target="#closeEnvelope"
																							aria-label="Complete Sleeve"
																							title="Mark the sleeve as complete"
																						>
																							<i className="bi bi-check-circle me-2"></i>
																							Complete Sleeve
																						</button>
																					</li>
																				</ul>
																			</div>
																		)}
																	</div>
																</div>

																<div className="tab-content" id="nav-tabContent">
																	<div className="tab-pane fade active show"
																		id="TotalRequested-detail" role="tabpanel"
																		aria-labelledby="TotalRequested">
																		{(docList.length === 0 && formList.length === 0 && signDocList.length === 0) && (
																			<div className="text-center py-5">
																				<i className="bi bi-inbox mb-3" style={{ fontSize: 64, color: "#c3c7ce" }}></i>
																				<div className="fw-semibold" style={{ fontSize: 24, color: "#a0a4ab" }}>
																					No requests found for this status.
																				</div>
																			</div>
																		)}

																		{docList.length > 0 &&
																			<>
																				<div className="section-content">
																					<h2 className="section-title">Documents</h2>
																					<div className="table-responsive">
																						<table className="sleeve-table">
																							<thead>
																								<tr>
																									<th style={{ width: '40%' }}>Document Name</th>
																									<th style={{ width: '18%' }}>
																										View
																									</th>
																									<th style={{ width: '20%' }}>Status</th>
																									{/* {parseInt(envelopeData.status_id) === 2 && (
																									<th style={{ width: '15%' }}>Expired/Expiring</th>
																								)} */}
																									<th style={{ width: '12%' }}>
																										Action
																									</th>
																								</tr>
																							</thead>
																							<tbody>
																								{docList.map((item, index) => (
																									<tr key={index}>
																										<td>{item.doc_name}</td>
																										<td>
																											{item.status_id > 1 ? (
																												<i
																													className="action-icon bi bi-eye"
																													onClick={(e) => onViewApproveRejectDoc(e, item)}
																													aria-hidden="true"
																												></i>
																											) : (
																												<span className="text-muted">Awaiting to Upload</span>
																											)}
																										</td>
																										<td>
																											<span
																												className={`status-badge ${item.status_id === 1 ? 'status-badge-pending' : item.status_id === 2 ? 'status-badge-received' : item.status_id === 3 ? 'status-badge-approved' : 'status-badge-rejected'}`}

																											>
																												{item.status_id === 1
																													? 'Awaiting to Upload'
																													: item.status_id === 2
																														? 'Received'
																														: item.status_id === 3
																															? 'Approved'
																															: 'Rejected'}
																											</span>
																										</td>
																										{/* {parseInt(envelopeData.status_id) === 2 && (
																										<td>
																											<span
																												className={item.is_expired_date ? 'text-danger' : 'text-primary'}
																											>
																												{item.expired_date}
																											</span>
																										</td>
																									)} */}
																										<td >
																											{/* {item.status_id < 3 && (
																											// <span
																											// 	onClick={(e) => handleApproveRejectDoc(e, item)}
																											// 	data-bs-toggle="tooltip"
																											// 	data-bs-placement="top"
																											// 	title="Click to Approve/Reject"
																											// 	className="text-primary cursor-pointer"
																											// >
																											// 	Approve/Reject
																											// </span>
																								
																										)} */}

																											<span
																												onClick={(e) => handleApproveRejectDoc(e, item)}
																												data-toggle="tooltip"
																												data-placement="right"
																												title=""
																												data-bs-original-title="Click me to Approve/Reject"
																												className="approve-reject-btn">Approve/Reject</span>
																										</td>
																									</tr>
																								))}
																							</tbody>
																						</table>
																					</div>
																				</div>
																			</>
																		}

																		{formList.length > 0 &&
																			<>
																				<div className="section-content">
																					<h2 className="section-title d-flex flex-wrap">
																						<div>
																							Information
																						</div>
																						{isDataDownload && (
																							<div className="d-flex gap-3 mt-sm-2">
																								<button type="button"
																									onClick={(e) => onDataDownload(e, 2)}
																									className="download-btn download-btn-excel">
																									<i className="bi bi-download me-2"
																										aria-hidden="true" /> Excel
																								</button>
																								<button type="button"
																									onClick={(e) => onDataDownload(e, 1)}
																									className="download-btn download-btn-pdf">
																									<i className="bi bi-download me-2"
																										aria-hidden="true" />PDF
																								</button>
																							</div>
																						)}
																					</h2>
																					<div className="table-responsive">
																						<table className="sleeve-table">
																							<thead>
																								<tr>
																									<th style={{ width: '40%' }}>Data Name</th>
																									<th style={{ width: '18%' }}>View</th>
																									<th style={{ width: '20%' }}>Status</th>
																									<th style={{ width: '15%' }}>Action</th>
																								</tr>
																							</thead>
																							<tbody>
																								{formList && formList.map((item, index) =>
																									<tr key={index}>
																										<td>{item.form_name}</td>
																										<td>
																											{item.status_id > 1 ? (
																												<i className="action-icon bi bi-eye"
																													onClick={(e) => handleViewDataForm(e, item)}
																													aria-hidden="true" />
																											) : (
																												<span className="text-muted">Awaiting to Upload</span>
																											)}
																										</td>
																										<td>
																											<span
																												className={`status-badge ${item.status_id === 1 ? `status-badge-pending` : item.status_id === 2 ? `status-badge-received` : item.status_id === 3 ? `status-badge-approved` : `status-badge-rejected`} `}>

																												{item.status_id === 1 ? `Awaiting to Upload` : item.status_id === 2 ? `Received` : item.status_id === 3 ? `Approved` : `Rejected`}
																											</span>
																										</td>
																										<td>
																											<span
																												onClick={(e) => handleApproveRejectForm(e, item)}
																												data-toggle="tooltip"
																												data-placement="right"
																												title=""
																												data-bs-original-title="Click me to Approve/Reject"
																												className="approve-reject-btn">Approve/Reject</span>

																											{/* {item.status_id < 3 && (
																											<span
																												onClick={(e) => handleApproveRejectForm(e, item)}
																												data-toggle="tooltip"
																												data-placement="right"
																												title=""
																												data-bs-original-title="Click me to Approve/Reject"
																												className="Action_perform">Approve/Reject</span>
																										)} */}

																										</td>
																									</tr>
																								)}
																							</tbody>
																						</table>
																					</div>
																				</div>
																			</>
																		}

																		{signDocList.length > 0 &&
																			<>
																				<div className="section-content">
																					<h2 className="section-title">Sign Documents</h2>
																					<div className="table-responsive">
																						<table className="sleeve-table">
																							<thead>
																								<tr>
																									<th style={{ width: '40%' }}>Document Name</th>
																									<th style={{ width: '18%' }}>
																										View
																									</th>
																									<th style={{ width: '20%' }}>Status</th>
																									{/* {parseInt(envelopeData.status_id) === 2 && (
																									<th style={{ width: '15%' }}>Expired/Expiring</th>
																								)} */}
																									<th style={{ width: '15%' }}>
																										Action
																									</th>
																								</tr>
																							</thead>
																							<tbody>
																								{signDocList && signDocList.map((item, index) =>
																									<tr key={index}>
																										<td>
																											<span>{item.doc_name}</span>
																											{(item.notes !== "") && (
																												<div className="mt-1 fz_13">
																													<small><b>Decline Reason:</b> {item.notes}</small>
																												</div>
																											)}
																										</td>
																										<td >
																											{((item.status_id > 1) && (item.status_id !== 5)) ? (
																												<i className="action-icon bi bi-eye"
																													onClick={(e) => onViewApproveRejectSignDoc(e, item)}
																													aria-hidden="true" />
																											) : (
																												<span className="text-muted">Awaiting to Upload</span>
																											)}
																										</td>
																										<td>
																											<span
																												className={`status-badge ${item.status_id === 1 ? `status-badge-pending` : item.status_id === 2 ? `status-badge-received` : item.status_id === 5 ? `status-badge-declined` : item.status_id === 3 ? `status-badge-approved` : `status-badge-rejected`}`}>
																												{item.status_id === 1 ? `Awaiting to Sign` : item.status_id === 2 ? `Received` : item.status_id === 5 ? `Declined` : item.status_id === 3 ? `Approved` : `Rejected`}
																											</span>
																										</td>

																										<td >
																											{(item.status_id !== 5) && (
																												<span
																													onClick={(e) => handleApproveRejectSignDoc(e, item)}
																													data-toggle="tooltip"
																													data-placement="right"
																													title=""
																													data-bs-original-title="Click me to Approve/Reject"
																													className="approve-reject-btn">Approve/Reject</span>
																											)}
																										</td>
																									</tr>
																								)}
																							</tbody>
																						</table>
																					</div>
																				</div>
																			</>
																		}
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									className={`tab-pane fade pt-4 message_accordion ${props.tabType === 'message' ? `active show` : ``}`}
									id="messages" role="tabpanel" aria-labelledby="messages-tab">
									<EnvMessages envelopeData={envelopeData} recipientList={recipientList}
										setLoading={setLoading} />
								</div>

								<EnvHistory envelopeData={envelopeData} />

								<EnvSetting envelopeData={envelopeData} setEnvelopeData={setEnvelopeData}
									setLoading={setLoading} syncStatusList={syncStatusList} />

							</div>

						</>
					}

					{isEditRequest &&
						<EditRequest setIsEditRequest={setIsEditRequest} envelopeData={envelopeData} isTemplate={isTemplate}
							setEnvelopeData={setEnvelopeData} setIsRefresh={setIsRefresh} setLoading={setLoading} />
					}
				</div>
			</section >

			<BulkMessage recipientList={recipientList} setRecipientList={setRecipientList} envelopeData={envelopeData}
				setLoading={setLoading} />

			<div ref={approveRejectDocumentModelRef} data-bs-toggle="offcanvas" data-bs-target="#ApproveRejectDoc"
				aria-controls="ApproveRejectDoc" />
			<ApproveRejectDoc docDetail={docDetail} setDocDetail={setDocDetail} setLoading={setLoading}
				statusList={statusList} setStatusList={setStatusList} docFormList={docFormList}
				setDocFormList={setDocFormList} setDocList={setDocList} />

			<div ref={DownloadDataModelRef} data-bs-toggle="offcanvas" data-bs-target="#DownloadDataDoc"
				aria-controls="DownloadDataDoc" />
			<DownloadDataDoc setLoading={setLoading} downloadDataList={downloadDataList}
				setDownloadDataList={setDownloadDataList} />

			<div ref={viewDocumentModelRef} data-bs-toggle="offcanvas" data-bs-target="#viewDocument"
				aria-controls="viewDocument" />
			<ViewDocument docDetail={docDetail} setDocDetail={setDocDetail} setLoading={setLoading} />

			<div ref={approveRejectDataModelRef} data-bs-toggle="offcanvas" data-bs-target="#ApproveRejectForm"
				aria-controls="ApproveRejectForm" />
			<ApproveRejectForm formDetail={formDetail} setFormDetail={setFormDetail} setLoading={setLoading}
				statusList={statusList} setStatusList={setStatusList} docFormList={docFormList}
				setDocFormList={setDocFormList} setFormList={setFormList} />

			<div ref={viewDataModelRef} data-bs-target="#viewDataForm" data-bs-toggle="offcanvas"
				aria-controls="viewDataForm" />
			<ViewDataForm formDetail={formDetail} setFormDetail={setFormDetail} setLoading={setLoading} />


			<div ref={viewSignDocumentModelRef} data-bs-toggle="offcanvas" data-bs-target="#viewSignDocument"
				aria-controls="viewSignDocument" />
			<ViewSignDocument windowHeight={windowHeight} setWindowHeight={setWindowHeight} signDocDetail={signDocDetail} setSignDocDetail={setSignDocDetail} setLoading={setLoading} />

			<div ref={approveRejectSignDocumentModelRef} data-bs-toggle="offcanvas" data-bs-target="#ApproveRejectSignDoc"
				aria-controls="ApproveRejectSignDoc" />
			<ApproveRejectSignDoc signDocDetail={signDocDetail} setSignDocDetail={setSignDocDetail} setLoading={setLoading}
				statusList={statusList} setStatusList={setStatusList} docFormList={docFormList}
				setDocFormList={setDocFormList} setDocList={setDocList} signDocList={signDocList} setSignDocList={setSignDocList} />


			<TransferEnvelope closeEnvelope={closeEnvelope} setCloseEnvelope={setCloseEnvelope}
				senderList={senderList} setLoading={setLoading} setIsRefresh={setIsRefresh} />

			<CloseEnvelope closeEnvelope={closeEnvelope} setCloseEnvelope={setCloseEnvelope}
				setLoading={setLoading} />

			<ResendEnvelope resendEnvelope={resendEnvelope} setResendEnvelope={setResendEnvelope}
				setLoading={setLoading} />
		</>
	);
}

export default ViewEnvelope;